import React, { useEffect, useState } from 'react'
import useHttp from '../../../hook/use-http'
import Chart from 'react-apexcharts'
import stats from 'wink-statistics';
import { BsZoomIn } from "react-icons/bs";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../../componets/Dashboard/DashboardMain/WaterMark";
import NoData_Kratos from "./NoData_Kratos"
import ChartLoader_Kratos from './ChartLoader_Kratos';

export default function EnergyBoxRange_Kratos({ title, apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [fieldname, SetFieldName] = useState("median_whPerKM");

  const appyData = (data) => {
    const res_result = data;
    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        type: 'boxPlot',
        data: []
      }]
      let y_data_set = [];
      temp_result.map(x => {
        if (x.median_whPerKM.values["50.0"] === null)
          x.median_whPerKM.values["50.0"] = 0
        y_data_set.push(x.median_whPerKM.values["50.0"]);
      })

      y_data_set = y_data_set.sort(function (a, b) { return a - b });
      let boxplot = stats.data.boxplot;
      let data_set = boxplot(y_data_set);
      res_result_final[0].data.push({ x: "KRATOS", y: [data_set.min.toFixed(2), data_set.q1.toFixed(2), data_set.median.toFixed(2), data_set.q3.toFixed(2), data_set.max.toFixed(2)] })
      setChartData((prestate) => res_result_final);
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }
  const appyDatakwh = (data) => {
    const res_result = data;
    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        type: 'boxPlot',
        data: []
      }]
      let y_data_set = [];

      temp_result.map(x => {
        if (x.median_NetkWh.values["50.0"] === null)
          x.median_NetkWh.values["50.0"] = 0
        y_data_set.push(parseFloat(x.median_NetkWh.values["50.0"]));
      })

      y_data_set = y_data_set.sort(function (a, b) { return a - b });
      let tempdata = []
      let boxplot = stats.data.boxplot;
      let data_set = boxplot(y_data_set);
      res_result_final[0].data.push({ x: "KRATOS", y: [data_set.min.toFixed(1), data_set.q1, data_set.median, data_set.q3, data_set.max] })
      setChartData((prestate) => res_result_final);
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }
  const options = {
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft',
        offsetX: -20,
        offsetY: -100,
      },
    },
    chart: {
      toolbar: {
        show: false
      },
      type: 'boxPlot',
      height: 350
    },
    yaxis: {
      title: {
        text: fieldname,
        show: true,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }

      },
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        }
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        }
      }
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#FFFFFF',
          lower: '#FFFFFF'
        }
      }
    }
  };

  useEffect(() => {
    if (apiend === "netenergyconsumption") {
      SetFieldName("kWh/km")
      fetchData({ url: API_URL_MAIN + "kratos_drive/" + apiend, body: { filterdata: gloablfilter } }, appyData)
    }
    else {
      SetFieldName("kWh")
      fetchData({ url: API_URL_MAIN + "kratos_drive/" + apiend, body: { filterdata: gloablfilter } }, appyDatakwh)
    }
  }, [gloablfilter, apiend])

  return (
    <>
      <div className="modal fade" id={"energybox"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Net Energy</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              {(isLoading) ? <ChartLoader_Kratos /> : ((chartdata.length == 0) ? <NoData_Kratos /> : <Chart options={options} series={chartdata} type="boxPlot" height={300} />)}
            </div>
          </div>
        </div>
      </div>

      <div className="titlebg" style={{ margin: "0px" }}><strong className="tlbg_kratos" style={{ float: "right", cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#energybox"} > <BsZoomIn /> </strong>
      </div>
      <div className="chartHGT">
        <WaterMark />
        {(isLoading) ? <ChartLoader_Kratos /> : ((chartdata.length == 0) ? <NoData_Kratos /> : <Chart options={options} series={chartdata} type="boxPlot" height={200} />)}
      </div>
    </>
  )
}
